export const countryTelData = require('country-telephone-data');

export const PHONE_CODES = {};
export const PHONE_FORMATS = {};
export const PHONE_CODES_ISO = {};
export const ALL_COUNTRIES = {};
countryTelData.allCountries
  .sort((a, b) => a.name.localeCompare(b.name))
  .forEach((country) => {
    const code = country.iso2.toUpperCase();
    PHONE_CODES[code] = `+${country.dialCode}`;
    PHONE_FORMATS[code] =
      (country.format || '')
        .replace(/^\+[\.]+(\-|)/, '')
        .replace(/(\s|\()/g, '')
        .replace(/\)/g, '-')
        .replace(/\./g, '#') || null;
    PHONE_CODES_ISO[`+${country.dialCode}`] = code;
    PHONE_CODES_ISO[`${country.dialCode}`] = code;
    ALL_COUNTRIES[country.name] = {
      countryPhoneCode: `${country.dialCode}`,
      countryName: country.name,
      ISO: code,
    };
  });

export const CANADA_NPA_CODES = [
  368, 403, 587, 780, 825, 236, 250, 604, 672, 778, 204, 431, 584, 428, 506, 709, 879, 867, 782, 902, 867, 226, 249,
  289, 343, 365, 382, 387, 416, 437, 519, 548, 613, 647, 683, 705, 742, 753, 807, 905, 782, 902, 942, 263, 354, 367,
  418, 438, 450, 468, 514, 579, 581, 819, 873, 306, 474, 639, 867,
];
